import { AnimatePresence, motion } from 'motion/react'
import { fadeAnimation } from '@lib/animate'

import GalleryCarousel, {
  type GalleryCarouselProps,
} from '@components/gallery-carousel'

export type GalleryProps = Pick<
  GalleryCarouselProps,
  | 'items'
  | 'hasArrows'
  | 'hasDots'
  | 'hasDrag'
  | 'hasClickToZoom'
  | 'hasCounter'
  | 'hasThumbnails'
  | 'preloadFirstImage'
>

const Gallery = ({
  items,
  hasArrows,
  hasDots,
  hasDrag,
  hasClickToZoom,
  hasCounter,
  hasThumbnails,
  preloadFirstImage,
}: GalleryProps) => {
  if (!items || items.length === 0) {
    return null
  }

  // Update ID to trigger transition animation
  const id = items.map((item) => item.id).join(',')

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={id}
        initial="hide"
        animate="show"
        exit="hide"
        variants={fadeAnimation}
      >
        <GalleryCarousel
          id={id}
          items={items}
          hasArrows={hasArrows}
          hasDots={hasDots}
          hasCounter={hasCounter}
          hasDrag={hasDrag}
          hasClickToZoom={hasClickToZoom}
          hasThumbnails={hasThumbnails}
          cornerControls
          preloadFirstImage={preloadFirstImage}
        />
      </motion.div>
    </AnimatePresence>
  )
}

export default Gallery
